import { INVALID_API_URL, MISSING_CLIENT_ID, WebchatError } from '../types'
import { isValidUrl } from './url'

export const checkConfiguration = (clientId: string, apiUrl: string): WebchatError | undefined => {
  if (!clientId) {
    return { type: 'configuration', message: MISSING_CLIENT_ID }
  }
  if (!isValidUrl(apiUrl)) {
    return { type: 'configuration', message: INVALID_API_URL }
  }
}
